<script>
import { h } from "vue";
import SecondaryPageLayout from "@/Layouts/SecondaryPageLayout.vue";

export default {
    layout: (_, page) =>
        h(SecondaryPageLayout, { title: "Terms of Use" }, () => page),
};
</script>

<script setup>
import { Head } from "@inertiajs/vue3";
import LegalDocument from "@/Components/Brand/LegalDocument.vue";

defineProps({
    terms: String,
});
</script>

<template>
    <Head>
        <title>Terms of Use | Gift Hero Wish Lists</title>
        <meta
            name="description"
            content="Read about the Gift Hero terms of use"
        />
        <meta property="og:title" content="Gift Hero Terms of Use" />
        <meta
            property="og:description"
            content="Read about the Gift Hero terms of use"
        />
        <meta property="og:url" :content="route('terms.show')" />
        <meta
            property="og:image"
            content="https://res.cloudinary.com/gift-hero/image/upload/v1685819255/lib/img/meta/og-image-1200x630-1.png"
        />
        <link rel="canonical" :href="route('terms.show')" />
    </Head>

    <LegalDocument :html="terms" />
</template>
